import { Pipe, PipeTransform, inject } from '@angular/core';

import { LanguageService } from '@fcom/ui-translate';
import { symbolToLangPath } from '@fcom/core/utils/cms-path-helpers';

@Pipe({
  name: 'resolveLinks',
  standalone: false,
})
export class ResolveLinksPipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(value: string): string {
    return this.legacySiteLinkLocale(value);
  }

  private legacySiteLinkLocale(value = ''): string {
    if (!value) {
      return value;
    }
    return symbolToLangPath(value, this.languageService.ddsLocaleValue as Parameters<typeof symbolToLangPath>[1]);
  }
}
